<template>
  <div class="login__signin">
    <md-progress-bar md-mode="indeterminate" v-if="loading"></md-progress-bar>
    <img :src="require('@/assets/img/valyoo-logo.svg')" alt="Logo BlueBox" />
    <div class="subtitle">¡Bienvenido a Valyoo! Ingrese a su cuenta</div>
    <form action="" class="signin">
      <input
        type="text"
        name=""
        id="login-user"
        placeholder="Ingrese su correo o DNI"
        v-model="creds.username"
        :class="{ 'input-error': errorLog }"
      />
      <input
        type="password"
        name=""
        id="login-pass"
        placeholder="Contraseña"
        v-model="creds.password"
        :class="{ 'input-error': errorLog }"
      />
      <div class="forgot-pass" @click="$emit('forgotPass')">
        ¿Ha olvidado su contraseña?
      </div>
      <button class="btn-scale" @click.stop.prevent="signIn">
        <span v-if="!loading">Iniciar sesión</span>
        <Loader v-else spin-ext="#fff" spin-int="white" />
      </button>
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Loader from "@/components/Loaderic";
import { setTimeout } from "timers";

export default {
  components: {
    Loader,
  },
  data() {
    return {
      creds: {
        username: null,
        password: null,
      },
      loading: false,
      errorLog: false,
    };
  },
  methods: {
    ...mapActions({
      login: "login",
    }),

    signIn() {
      if (this.creds.username && this.creds.password) {
        this.loading = true;
        this.login(this.creds).then(
          (r) => {
            this.loading = false;
            this.errorLog = false;
            console.log(r);
            this.$toasted.success("¡Bienvenido!", {
              theme: "bubble",
              position: "top-left",
              duration: 1000,
              className: "short-message",
            });
            this.$store.commit(
              "SET_BUSINESSID",
              this.$store.state.login.currentUser.business[0].id
            );
            this.$store.dispatch("getBusiness", 1);
            setTimeout(() => {
              if (this.$store.state.login.currentUser.business[0].roleIn == "owner") {
                this.$router.push("/panel");
              } else {
                this.$router.push({ name: "T-Registros" });
              }
            }, 1000);
          },
          (error) => {
            console.log("EL ERROR ES: ", error);
            this.loading = false;
            this.errorLog = true;

            this.$toasted.show("Usuario y/o contraseña incorrecta", {
              theme: "bubble",
              position: "top-left",
              duration: 5000,
            });
          }
        );
      } else {
        this.errorLog = true;
        this.$toasted.show("Usuario y/o contraseña inválidas", {
          theme: "bubble",
          position: "top-left",
          duration: 5000,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//3-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img + $img);
}
//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}
.login__signin {
  width: 75%;
  @include mq($lg) {
    width: 21rem;
  }
  img {
    width: 80%;
    display: block;
    margin: 1rem auto;
  }
  .subtitle {
    text-align: center;
    font-size: 0.89rem;
    line-height: 1.2rem;
  }
  .signin {
    margin: 2rem auto;
    & > * {
      display: block;
    }
    input[type="text"] {
      padding-left: 0.5rem;
      width: 100%;
      height: 3rem;
      border-bottom: 1px solid #e9e9f0;
      margin-bottom: 1rem;
      color: #4d4f5c;
    }
    input[type="password"] {
      padding-left: 0.5rem;
      width: 100%;
      height: 3rem;
      border-bottom: 1px solid #e9e9f0;
      margin-bottom: 1rem;
      color: #4d4f5c;
    }
    input::placeholder {
      color: #4d4f5c;
    }
    .forgot-pass {
      text-align: right;
      font-size: 0.75rem;
      color: #4d4f5c;
      @include mq($md) {
        cursor: pointer;
      }
    }
    button {
      display: block;
      margin-top: 2rem;
      background-color: $b-emph;
      width: 100%;
      color: #fff;
      height: 3rem;
      border-radius: 0.3rem;
    }
  }
}

.input-error {
  border-bottom: 1px solid red !important;
}
</style>
